import { API_URL } from '../../../app-config/constants';
import MeetingTemplateDetails from '../../../types/MeetingTemplateDetails';
import MeetingTemplateDto from '../../../types/MeetingTemplateDto';
import { get, post, put, remove } from '../request';

const ENTRY = `${API_URL}/meeting-templates`;

getMeetingTemplates.operation = 'READ';
export function getMeetingTemplates(
    requiredPermission: 'EDIT' | 'USE' | 'SEE',
    type?: 'COMPANY' | 'USER'
): Promise<MeetingTemplateDto[]> {
    return get(ENTRY, {
        getData: {
            'required-permission': requiredPermission,
            type,
        },
    });
}

getMeetingTemplate.operation = 'READ';
export function getMeetingTemplate(id: string): Promise<MeetingTemplateDto> {
    return get(`${ENTRY}/${id}`);
}

saveTemplate.operation = 'UPDATE';
saveTemplate.invalidates = ['getMeetingTemplates'];
export function saveTemplate(payload: MeetingTemplateDetails & { id: string }): Promise<MeetingTemplateDto> {
    return put(`${ENTRY}/${payload.id}`, { postData: payload });
}

createTemplate.operation = 'CREATE';
createTemplate.invalidates = ['getMeetingTemplates'];
export function createTemplate(payload: MeetingTemplateDetails): Promise<MeetingTemplateDto> {
    return post(`${ENTRY}`, { postData: payload });
}

removeTemplate.operation = 'DELETE';
removeTemplate.invalidates = ['getMeetingTemplates'];
export function removeTemplate(id: string): Promise<void> {
    return remove(`${ENTRY}/${id}`);
}
